import { brandConfig } from "@nitro-ape/shared/lib/brand-config";
import { Button } from "@heroui/button";
import { i18n as i18nGlobal } from "@/lib/i18n";
import { Link } from "@tanstack/react-router";
import { getEnv } from "@/lib/env";

const ErrorPage = () => {
  return (
    <section className="relative flex h-screen w-screen flex-col items-center justify-center gap-1">
      <img
        alt={i18nGlobal._({
          id: "components.errorPage.backgroundAlt",
          message: "Background visual",
          comment:
            "Alt text for the decorative background image on the error page.",
        })}
        src={brandConfig(getEnv).loginBackgroundImagePath}
        className="absolute inset-0 z-0 h-full w-full"
      />
      <div className="z-20 flex flex-col items-center gap-3">
        <h1 className="text-3xl">
          {i18nGlobal._({
            id: "components.errorPage.title",
            message: "Error",
            comment: "Heading shown on the error page.",
          })}
        </h1>
        <h3 className="text-base font-light">
          {i18nGlobal._({
            id: "components.errorPage.description",
            message: "Something went wrong",
            comment: "Subheading shown on the error page.",
          })}
        </h3>
        <Button
          as={Link}
          to="/explore"
          className="bg-green/10 text-green data-[hover=true]:bg-green/20 mt-3 rounded-xl text-lg"
          variant="solid"
          size="lg"
        >
          {i18nGlobal._({
            id: "components.errorPage.cta",
            message: "Go trade",
            comment:
              "CTA button on the error page that navigates back to the pump page.",
          })}
        </Button>
      </div>
    </section>
  );
};
export default ErrorPage;
